import { Link, NavLink } from "react-router-dom";
import { Menu, LogOut } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { useLang } from "@/context/LangContext";

const LINK_CLS = "rounded-full px-3 py-2 text-sm font-semibold text-muted-foreground transition-colors hover:bg-muted hover:text-foreground";

export const DesktopNav = ({ links, user, onLogout }) => {
  const { t } = useLang();
  return (
    <nav className="mr-2 hidden items-center gap-1 lg:flex">
      {links.map((l) => (
        <NavLink key={l.id} to={l.to} end data-testid={`nav-link-${l.id}`} className={LINK_CLS}>{l.label}</NavLink>
      ))}
      {!user && (
        <Link to="/register" data-testid="nav-link-register" className="ml-1 rounded-full bg-primary px-4 py-2 text-sm font-bold text-primary-foreground transition-opacity hover:opacity-90">
          {t("nav_register")}
        </Link>
      )}
      {user && (
        <button onClick={onLogout} data-testid="nav-logout-button" className={`${LINK_CLS} flex items-center gap-1`}>
          <LogOut className="h-4 w-4" />{t("nav_logout")}
        </button>
      )}
    </nav>
  );
};

export const MobileNav = ({ links, user, onLogout, open, setOpen }) => {
  const { t } = useLang();
  const close = () => setOpen(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button data-testid="mobile-menu-button" className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-card lg:hidden" aria-label="menu">
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-72">
        <SheetTitle className="mb-6">{t("nav_home")}</SheetTitle>
        <div className="flex flex-col gap-1">
          {links.map((l) => (
            <Link key={l.id} to={l.to} onClick={close} data-testid={`mobile-nav-link-${l.id}`} className="rounded-lg px-3 py-3 font-semibold hover:bg-muted">{l.label}</Link>
          ))}
          {!user && <Link to="/register" onClick={close} data-testid="mobile-nav-link-register" className="mt-2 rounded-lg bg-primary px-3 py-3 text-center font-bold text-primary-foreground">{t("nav_register")}</Link>}
          {user && <button onClick={onLogout} data-testid="mobile-logout-button" className="rounded-lg px-3 py-3 text-left font-semibold hover:bg-muted">{t("nav_logout")}</button>}
        </div>
      </SheetContent>
    </Sheet>
  );
};
